import React, { type JSX } from 'react'

import { useNavigate } from '@lib/react-router-dom'

import {
  useHideNotifications,
  useNotificationAlerts,
  useNotificationFunctionality,
} from '@utils/notifications'

import { NotificationType } from '@model/Notification'

import { SystemNotification } from '../systemNotification/SystemNotification'

export const PlatformNotification = (): JSX.Element => {
  const { enableNotifications } = useNotificationFunctionality()
  const { hideNotifications } = useHideNotifications()
  const navigate = useNavigate()
  const { platformNotifications } = useNotificationAlerts()

  if (!platformNotifications.length || !enableNotifications) {
    return <></>
  }
  const notification = platformNotifications[0]

  return (
    <SystemNotification
      readMore={() => navigate(`/profile/notifications/${notification.id}`)}
      title={notification.title}
      close={() => hideNotifications([NotificationType.Platform])}
    />
  )
}
